export var ProjectManagerStorageType;
(function (ProjectManagerStorageType) {
    ProjectManagerStorageType["LOCAL"] = "LOCAL";
    ProjectManagerStorageType["REMOTE"] = "REMOTE";
})(ProjectManagerStorageType || (ProjectManagerStorageType = {}));
